import { render } from "./MembershipTerms.vue?vue&type=template&id=34faa45c&scoped=true"
import script from "./MembershipTerms.vue?vue&type=script&lang=js"
export * from "./MembershipTerms.vue?vue&type=script&lang=js"

import "./MembershipTerms.vue?vue&type=style&index=0&id=34faa45c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34faa45c"]])

export default __exports__